import { View } from 'backbone';
import eventBus        from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import constants       from "Constants.js";
import template from 'advanced-inputs/control_ranking.ejs';
import util from 'util/Util.js';
//=====================================================================
//
// An instance of this view represents a Ranking control.
//
// Alfonso Cabral, March 4, 2016
//
//=====================================================================
class RankingControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-ranking';
        this.model.set('flag',true,{silent:true});

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender );
        this.listenTo(this.model, 'change', super.render);
        this.listenTo( eventBus, 'addRankingItemOnList', super.render);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default RankingControlView;
